//일단 두종류만 주로 쓰기 때문에...바꾸도록 하겠음.
interface IConfigBase {
    useMock: boolean;
  }
  
  interface IConfig extends IConfigBase {
      host : string;
      hostRes : string;
      contextPath : string;
  }
  
  const config : IConfig = (() : IConfig => {
    const commonSetting : IConfigBase = {
      useMock: false,
      //   loginKey:'inbrain_trainer_admin_header',
      // userInfoKey:'inbrain_trainer_admin_user_info',   sessionTimeOut: 10000000,
      // //ms
    };
  
    switch (process.env.REACT_APP_ENV) {
      case 'development':
        return {
          ...commonSetting,
         // host: 'https://inbrain.co.kr/cog/exam',
           host: 'http://localhost:8080/',
          // hostRes: 'http://localhost:8080/resources',
            hostRes: '',
          // contextPath:'/cog/admin',
          contextPath: ''
        };
    default:
        return {
          ...commonSetting,
          host: '/',
          hostRes: '/',
          // contextPath:'/cog/admin',
          contextPath: ''
          };
    }
  })();
  
  export default config;